import { render, staticRenderFns } from "./LprWebPayment.vue?vue&type=template&id=206f534e&"
import script from "./LprWebPayment.vue?vue&type=script&lang=js&"
export * from "./LprWebPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports